import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { CityFAQRichAnswer } from '@/components/ServiceFAQRichAnswer';
import type { City } from '@/data/cities';

interface Props { city: City }

const VilleFAQ = ({ city }: Props) => (
  <section className="py-16 md:py-20 px-6 lg:px-8 bg-background">
    <div className="max-w-3xl mx-auto">
      <div className="text-center mb-10">
        <p className="text-xs font-heading font-semibold uppercase tracking-[0.15em] text-primary mb-2">Questions fréquentes</p>
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground">
          FAQ {city.name}
        </h2>
      </div>

      <Accordion type="single" collapsible className="space-y-3">
        {city.faq.map((item, i) => (
          <AccordionItem key={i} value={`faq-${i}`} className="border border-border rounded-xl px-6 bg-background data-[state=open]:border-primary/30">
            <AccordionTrigger className="font-heading text-sm font-semibold text-foreground hover:no-underline py-5">
              {item.q}
            </AccordionTrigger>
            <AccordionContent className="text-sm text-muted-foreground leading-relaxed pb-5">
              <CityFAQRichAnswer answer={item.a} />
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
      <div className="text-center mt-8">
        <Link to="/faq" onClick={() => window.scrollTo(0, 0)} className="inline-flex items-center gap-2 text-primary font-heading font-medium text-sm hover:gap-3 transition-all">
          Voir toutes les questions <ArrowRight size={14} />
        </Link>
      </div>
    </div>
  </section>
);

export default VilleFAQ;
